'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var Menu = require('../Menu/Menu.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PageCanvasMenu = (props) => {
    const location = reactRouterDom.useLocation();
    const { items, isCurrentItem } = props;
    return React__default["default"].createElement(Menu["default"], { items: items, currentItem: location.pathname, isCurrentItem: isCurrentItem });
};

exports["default"] = PageCanvasMenu;
